module.exports = __webpack_public_path__ + "static/media/vis11.854b1d97.jpeg";